import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ className = "bg-surface-container-low dark:bg-inverse-surface full-width border-t border-outline-variant mt-auto" }) => {
  return (
    <footer className={className}>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-gutter px-margin-mobile md:px-margin-desktop py-12 max-w-container-max mx-auto w-full">
        <div className="col-span-1 md:col-span-1 mb-8 md:mb-0">
          <Link className="font-headline-md text-headline-md text-primary flex items-center gap-2 mb-4 hover:text-primary dark:hover:text-inverse-primary transition-colors" to="/">
            <span className="material-symbols-outlined filled">water_drop</span>
            TankCare
          </Link>
          <p className="font-body-md text-body-md text-on-surface-variant mt-4">Premium hygiene and maintenance for elite aquatic systems.</p>
        </div>
        <div className="col-span-1 md:col-span-3 flex flex-col md:flex-row justify-end items-start md:items-center gap-6 md:gap-12">
          <ul className="flex flex-col md:flex-row gap-4 md:gap-8">
            <li><Link className="font-body-md text-body-md text-on-surface-variant hover:text-primary transition-colors" to="/terms">Terms of Service</Link></li>
            <li><Link className="font-body-md text-body-md text-on-surface-variant hover:text-primary transition-colors" to="/sustainability">Sustainability</Link></li>
            <li><Link className="font-body-md text-body-md text-on-surface-variant hover:text-primary transition-colors" to="/contact">Contact Us</Link></li>
            <li><Link className="font-body-md text-body-md text-on-surface-variant hover:text-primary transition-colors" to="/about">About Us</Link></li>
            <li><Link className="font-body-md text-body-md text-on-surface-variant hover:text-primary transition-colors" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="col-span-1 md:col-span-4 mt-8 pt-8 border-t border-outline-variant/30 text-left md:text-center flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body-md text-body-md text-on-surface-variant text-sm">© 2026 A web by Mirza. All rights reserved.</p>
          <div className="flex gap-4">
            <a className="text-on-surface-variant hover:text-primary transition-colors" href="#"><span className="material-symbols-outlined">public</span></a>
            <a className="text-on-surface-variant hover:text-primary transition-colors" href="#"><span className="material-symbols-outlined">share</span></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
